const green = { r: 0, g: 255, b: 77, a: 1 };
const pink = { r: 255, g: 56, b: 122, a: 1 };
const yellow = { r: 255, g: 255, b: 0, a: 1 };
const orange = { r: 255, g: 128, b: 0, a: 1 };
const white = { r: 255, g: 255, b: 255, a: 1 };
export const transBlack = { r: 0, g: 0, b: 0, a: 0.1 };

export const Colours = {
    green,
    pink,
    yellow,
    orange,
    white,
}

export const colourArray = [
    green,
    yellow,
];